"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _GiveawayTable = _interopRequireDefault(require("./GiveawayTable.vue"));
var _giveaway = require("@/types/giveaway");
var GiveAwayPage = /*#__PURE__*/function (_Vue) {
  function GiveAwayPage() {
    var _this;
    (0, _classCallCheck2.default)(this, GiveAwayPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, GiveAwayPage, [].concat(args));
    (0, _defineProperty2.default)(_this, "tabName", "gift");
    (0, _defineProperty2.default)(_this, "GiveawayType", _giveaway.GiveawayType);
    return _this;
  }
  (0, _inherits2.default)(GiveAwayPage, _Vue);
  return (0, _createClass2.default)(GiveAwayPage);
}(_vuePropertyDecorator.Vue);
GiveAwayPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    GiveawayTable: _GiveawayTable.default
  }
})], GiveAwayPage);
var _default = exports.default = GiveAwayPage;